import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import config from 'config';
import gather from 'tools/gather';

export const getData = createAsyncThunk('getData', async () => {
  return await gather(`${config.apiUrl}/data`).get();
});

export const loadingSlice = createSlice({
  name: 'data',
  initialState: {
    data: {} as any,
  },
  reducers: {
    //
  },
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
  },
});

export default loadingSlice.reducer;
